import { HDateHour } from "@shared/src/datatypes/HDateHour";

export class FilterHDateHourDto {

    public dateHourFrom: HDateHour;
    public dateHourTo: HDateHour;

    public previousDateHourFrom: HDateHour;

    public static default(): FilterHDateHourDto {

        let result: FilterHDateHourDto = new FilterHDateHourDto();
        result.loadDefault();
        return result;
    }

    public loadDefault(){
        this.dateHourFrom = HDateHour.todayFirstMoment();
        this.dateHourTo = HDateHour.todayLastMoment();
        this.previousDateHourFrom = this.dateHourFrom;
    }

    public static isValid(value: FilterHDateHourDto) {
        if (value == null)
            return false;

        if (!HDateHour.isValidPeriodNotNullAllowed(value.dateHourFrom, value.dateHourTo))
            return false;

        return true;
    }
}
